import { useEffect, useState } from "react";
import { api, useCan, useData } from "../state";

export type CustomerSummary = { id: string; name: string; points: number; orderCount: number };
const cache = new Map<string, CustomerSummary | null>();

/**
 * The customer with this phone number. Staff who may see the customer list find them there; cashiers and waiters, who
 * may not, ask the server about this one number only.
 */
export function useCustomerByPhone(phone: string | undefined): CustomerSummary | undefined {
  const can = useCan(), customers = useData("customers");
  const listed = phone ? customers.find((entry) => entry.phone === phone) : undefined;
  const [looked, setLooked] = useState<CustomerSummary | null | undefined>(phone ? cache.get(phone) : undefined);
  const ask = Boolean(phone && /^\+?\d{9,15}$/.test(phone) && !can("customers.read") && can("orders.create"));
  useEffect(() => {
    if (!ask || !phone) return setLooked(undefined);
    if (cache.has(phone)) return setLooked(cache.get(phone));
    let current = true;
    const timer = setTimeout(() => void api("customer.lookup", { phone }).then((found) => { cache.set(phone, found); if (current) setLooked(found); }).catch(() => undefined), 300);
    return () => { current = false; clearTimeout(timer); };
  }, [ask, phone]);
  return listed ?? (ask ? looked ?? undefined : undefined);
}
